import React from 'react';
import propTypes from "prop-types";
import { Form, Input, Dropdown, Message } from 'semantic-ui-react';
import ConfirmModal from "../../common/ConfirmModal";
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { URL_SALE } from '../../../constances';
import { GET, PATCH, POST } from '../../../frameworks/HttpClient';

export default function SaleOrderLatexModal(props) {
	const [loading, setLoading] = React.useState(false);
	const [errorMessages, setErrorMessages] = React.useState(null);
	const [options, setOptions] = React.useState([]);
	
	const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: { 
			type: "sell",
			advice: props.data ? props.data.advice : "",
			contact: props.data ? props.data.contact : "",
			buyer: props.data ? props.data.buyer : "",
			packing: props.data ? props.data.packing : "",
			weight: props.data ? parseFloat(props.data.weight) : "" 
		},
    validationSchema: Yup.object().shape({
			advice: Yup.string().required("กรุณากรอกข้อมูล"),
			contact: Yup.string().required("กรุณากรอกข้อมูล"),
			buyer: Yup.string().required("กรุณากรอกข้อมูล"),
			packing: Yup.string().required("กรุณากรอกข้อมูล"),
			weight: Yup.number().required("กรุณากรอกข้อมูล")
		}),
    onSubmit: (values) => handleSubmit(values),
  });

	const handleSubmit = async (values) => {
		if (!props.tankTransaction) {
			setErrorMessages("ไม่พบข้อมูล TANK Transaction");
			return;
		}
		
		// Prepare data
		setLoading(true);
		const saleTransaction = props.data ? props.data.id : null;
		let response = null;
		try {
			if (saleTransaction) // Update
				response = await PATCH(`${URL_SALE.CONCENTRATED_LATEX_SELL_TRANSACTION}${saleTransaction}/`, values);
			else // Create
				response = await POST(
					URL_SALE.CONCENTRATED_LATEX_SELL_TRANSACTION, 
					{...values, tank_transaction: props.tankTransaction});
				
		} catch (error) {
			setErrorMessages(error.errorMessages);
		} finally {
			setLoading(false);
		}

		if (response)
			props.onClose();
	}

	const fetchOptions = async () => {
		try {
			const response = await GET(URL_SALE.PACKING);
			setOptions(
				response.data.map(item => ({value: item.name, text: item.name}))
			);
		} catch (error) {
			setErrorMessages(error.errorMessages);
		}
	}

	React.useEffect(() => {
		if (props.open) {
			setErrorMessages(null);
			formik.resetForm();
			fetchOptions();
		}
	}, [props.open]);

	return (
		<ConfirmModal
			open={props.open}
			title={props.data ? "แก้ไขการขายน้ำยางข้น" : "ขายน้ำยางข้น"}
			size={"tiny"}
			loading={loading}
			negativeText={"ยกเลิก"}
			positiveText={props.data ? "แก้ไข" : "ยืนยัน"}
			positiveColor={props.data ? "yellow" : "green"}
			onClose={props.onClose}
			onConfirm={formik.handleSubmit}
			onCancel={props.onClose}
			detail={
				<div>
					{errorMessages && (
						<Message 
							negative
							header={"เกิดข้อผิดพลาด"}
							content={errorMessages}/>
					)}

					<Form style={{textAlign: "right" ,width: "80%"}}>
						<Form.Field 
							inline
							style={{width: "65%"}}
							label={"Advice"}
							control={Input}
							placeholder={"Advice"}
							name={"advice"}
							error={formik.errors.advice}
							value={formik.values.advice}
							onChange={formik.handleChange}/>
						
						<Form.Field 
							inline
							style={{width: "65%"}}
							label={"Contact"}
							control={Input}
							placeholder={"Contact"}
							name={"contact"}
							error={formik.errors.contact}
							value={formik.values.contact}
							onChange={formik.handleChange}/>
						
						<Form.Field 
							inline
							style={{width: "65%"}}
							label={"Buyer"}
							control={Input}
							placeholder={"Buyer"}
							name={"buyer"}
							error={formik.errors.buyer}
							value={formik.values.buyer}
							onChange={formik.handleChange}/>
						
						<Form.Field 
							inline
							style={{width: "65%"}}
							label={"Packing"}
							control={Dropdown}
							placeholder={"เลือก..."}
							selection
							options={options}
							name={"packing"}
							error={formik.errors.packing}
							value={formik.values.packing}
							selectOnBlur={false}
							onChange={(_, data) => {
								formik.setFieldValue(data.name, data.value)
							}}/>
						
						<Form.Field 
							inline
							style={{width: "65%"}}
							label={"น้ำหนัก (kg)"}
							control={Input}
							placeholder={"น้ำหนัก (kg)"}
							name={"weight"}
							error={formik.errors.weight}
							value={formik.values.weight}
							onChange={formik.handleChange}/>
					</Form>
				</div>
			}
		/>
	)
}

SaleOrderLatexModal.defaultProps = {
	open: false,
	tankTransaction: null,
	data: null,
	onClose: () => {},
	
}

SaleOrderLatexModal.propTypes = {
	open: propTypes.bool,
	tankTransaction: propTypes.string,
	data: propTypes.object,
	onClose: propTypes.func,
}